import React from "react";
import { renderBlocks } from "../../utils/richtext";

export default function SlaContent ({ headline, content }) {
  if (!content || !content.blocks) return null;

  return (
    <section className="page-section row section">
      <div className="col-xs-12">
        <h1 className="page-title">{headline}</h1>
        {renderBlocks(content.blocks)}
      </div>
    </section>
  );
}
